import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useCreateFlash, useCurrentUser } from '@hooks';
import { new_session_path } from '@routes';

const ProtectedRoute = () => {
  const location = useLocation();
  const { currentUser } = useCurrentUser(false);
  const { mutate: createFlashMessage } = useCreateFlash(
    new_session_path({ returning_url: location.pathname })
  );
  if (!currentUser) {
    createFlashMessage({
      type: 'notice',
      message: 'You must be logged in to access that page',
    });
  }

  return <Outlet />;
};

export default ProtectedRoute;
